import { FsEntryType } from '@lucidlink/sdk';
import { MAX_MULTIPART_SEGMENTS, RECOGNISED_MULTIPART_EXTENSIONS, } from '#constants';
export const checkIfFileAndHasExtensionFromFileName = (fileName) => {
    const nameArray = fileName.split('.');
    const extension = nameArray.at(-1);
    // Display extensions only for files which:
    // - have at least one dot in their name
    // - have at least one character before the dot
    if ((nameArray.length > 2 ||
        (nameArray.length === 2 && nameArray.at(0)?.length)) &&
        extension) {
        return true;
    }
    return false;
};
export const checkIfFileAndHasExtension = (entry) => {
    if (entry.key.type === FsEntryType.FILE) {
        return checkIfFileAndHasExtensionFromFileName(entry.name);
    }
    return false;
};
export const extractFileExtensionFromFileName = (fileName) => {
    const nameArray = fileName.split('.');
    return (nameArray.at(-1) || '').toLowerCase();
};
export const extractFileExtension = (file) => extractFileExtensionFromFileName(file.name);
export const extractRecognizedMultipartFileExtensionFromFileName = (fileName) => {
    const segments = fileName.split('.');
    // No dot at all → no extension
    if (segments.length < 2) {
        return '';
    }
    // Prefer the longest recognised multipart suffix (e.g. "tar.gz"),
    // trying progressively shorter suffixes before falling back. Anchoring at
    // the end avoids treating dots in the name (dates, versions) as extensions.
    const maxParts = Math.min(MAX_MULTIPART_SEGMENTS, segments.length - 1);
    for (let count = maxParts; count >= 2; count--) {
        const candidate = segments.slice(-count).join('.').toLowerCase();
        if (RECOGNISED_MULTIPART_EXTENSIONS.has(candidate)) {
            return candidate;
        }
    }
    return '';
};
export const extractRecognizedMultipartFileExtension = (file) => extractRecognizedMultipartFileExtensionFromFileName(file.name);
